var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49935 14.9999H5.83268C6.08268 14.9999 6.24935 14.9166 6.41602 14.7499L15.5827 5.58325C15.916 5.24992 15.916 4.74992 15.5827 4.41659L12.2493 1.08325C11.916 0.749919 11.416 0.749919 11.0827 1.08325L1.91602 10.2499C1.74935 10.4166 1.66602 10.5833 1.66602 10.8333V14.1666C1.66602 14.6666 1.99935 14.9999 2.49935 14.9999ZM3.33268 11.1666L11.666 2.83325L13.8327 4.99992L5.49935 13.3333H3.33268V11.1666ZM17.4993 19.1666C17.9993 19.1666 18.3327 18.8333 18.3327 18.3333C18.3327 17.8333 17.9993 17.4999 17.4993 17.4999H2.49935C1.99935 17.4999 1.66602 17.8333 1.66602 18.3333C1.66602 18.8333 1.99935 19.1666 2.49935 19.1666H17.4993Z",
    fill: "#E0733D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.fa4d3617f7bd70f98b5450df6ff39415.svg";
export { ForwardRef as ReactComponent };